import React from 'react';
import loadable from '@loadable/component';

const UserReviews = loadable(() =>
  import(/* webpackChunkName: "reviews" */ './reviews')
);

const UserReviewsLoader = props => <UserReviews {...props} />;

export default UserReviewsLoader;
